/* eslint-disable */

/**
 * ⚠️ This is not owned or maintained by the Arcade team.
 * Please refer to the official Arcade design system for supported and maintained components.
 *
 * The concept of "Prominence" attached to arcade buttons.
 */
export enum ButtonProminence {
  CLIENT_COULD_NOT_PARSE_BUTTON_PROMINENCE = "CLIENT_COULD_NOT_PARSE_BUTTON_PROMINENCE",
  STANDARD = "STANDARD",
  PROMINENT = "PROMINENT",
  SUBTLE = "SUBTLE",
}
